
import { defineComponent } from "vue";
import CustomRadioButton from "../common/CustomRadioButton.vue";
export default defineComponent({
  name: "CreateSubscription",
  components: { CustomRadioButton },
  props: ["subscriptions", "modelValue", "subscription"],
  emits: ["update:modelValue", "update:subscription", "submit"],
});
